module.exports = __webpack_public_path__ + "img/article-bg.e67cfb4d.png";